(() => {
  if (customElements.get('ss-sale-countdown')) return;

  class SaleCountdown extends HTMLElement {
    connectedCallback() {
      this.sale = this.querySelector('[data-ss-countdown-sale]');
      this.regular = this.querySelector('[data-ss-countdown-regular]');
      this.clock = this.querySelector('[data-ss-countdown-time]');
      const end = this.getAttribute('data-end') || '';
      this.deadline = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/.test(end)
        ? Date.parse(end)
        : NaN;
      if (!this.sale || !this.regular || !this.clock) return;
      if (this.tick()) this.timer = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    tick() {
      const remaining = Math.ceil((this.deadline - Date.now()) / 1000);
      if (!Number.isFinite(remaining) || remaining <= 0) {
        const wasActive = !this.sale.hidden;
        this.sale.hidden = true;
        this.regular.hidden = false;
        window.clearInterval(this.timer);
        if (wasActive) {
          window.requestAnimationFrame(() => {
            if (window.theme && window.theme.announcementBar) window.theme.announcementBar.init();
            window.dispatchEvent(new Event('resize'));
          });
        }
        return false;
      }
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      this.clock.textContent = [hours, minutes, seconds].map(value => String(value).padStart(2, '0')).join(' : ');
      this.sale.hidden = false;
      this.regular.hidden = true;
      return true;
    }
  }

  customElements.define('ss-sale-countdown', SaleCountdown);
})();
